/* Metabolae shared behaviour: carousels, countdown, bundle selector */
(function () {
  'use strict';

  /* ---------- Carousels (arrows scroll the track by one card) ---------- */
  function initCarousels(root) {
    root.querySelectorAll('.mb-carousel').forEach(function (carousel) {
      if (carousel.dataset.mbInit) return;
      carousel.dataset.mbInit = '1';
      var track = carousel.querySelector('.mb-carousel__track');
      if (!track) return;
      var step = function () {
        var first = track.firstElementChild;
        if (!first) return track.clientWidth;
        var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 0) || 0;
        return first.getBoundingClientRect().width + gap;
      };
      carousel.querySelectorAll('.mb-carousel__arrow--prev').forEach(function (b) {
        b.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      });
      carousel.querySelectorAll('.mb-carousel__arrow--next').forEach(function (b) {
        b.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      });
      var dots = carousel.querySelector('.mb-dots');
      if (dots) {
        var items = track.children.length;
        dots.innerHTML = '';
        for (var i = 0; i < items; i++) {
          var d = document.createElement('span');
          if (i === 0) d.className = 'is-active';
          dots.appendChild(d);
        }
        track.addEventListener('scroll', function () {
          var idx = Math.round(track.scrollLeft / step());
          Array.prototype.forEach.call(dots.children, function (el, j) {
            el.classList.toggle('is-active', j === idx);
          });
        }, { passive: true });
      }
    });
  }

  /* ---------- Evergreen countdown (announcement bar) ---------- */
  function initCountdowns(root) {
    root.querySelectorAll('[data-mb-countdown]').forEach(function (el) {
      if (el.dataset.mbInit) return;
      el.dataset.mbInit = '1';
      var hours = parseFloat(el.dataset.mbCountdown) || 2;
      var key = 'mb_countdown_end_' + (el.dataset.mbKey || 'default');
      var end;
      try { end = parseInt(localStorage.getItem(key), 10); } catch (e) { end = NaN; }
      var now = Date.now();
      if (!end || isNaN(end) || end < now) {
        end = now + hours * 3600 * 1000;
        try { localStorage.setItem(key, String(end)); } catch (e) { /* storage unavailable */ }
      }
      var h = el.querySelector('[data-mb-h]');
      var m = el.querySelector('[data-mb-m]');
      var s = el.querySelector('[data-mb-s]');
      var pad = function (n) { return (n < 10 ? '0' : '') + n; };
      var tick = function () {
        var diff = Math.max(0, end - Date.now());
        var totalS = Math.floor(diff / 1000);
        if (h) h.textContent = pad(Math.floor(totalS / 3600));
        if (m) m.textContent = pad(Math.floor((totalS % 3600) / 60));
        if (s) s.textContent = pad(totalS % 60);
        if (diff <= 0) {
          end = Date.now() + hours * 3600 * 1000;
          try { localStorage.setItem(key, String(end)); } catch (e) { /* ignore */ }
        }
      };
      tick();
      setInterval(tick, 1000);
    });
  }

  /* ---------- Bundle / variant selector on the product page ---------- */
  function initBundleSelectors(root) {
    root.querySelectorAll('[data-mb-bundles]').forEach(function (wrap) {
      if (wrap.dataset.mbInit) return;
      wrap.dataset.mbInit = '1';
      var formId = wrap.dataset.mbForm;
      var form = formId ? document.getElementById(formId) : null;
      var priceOut = document.querySelectorAll('[data-mb-atc-price="' + wrap.dataset.mbSection + '"]');
      var compareOut = document.querySelectorAll('[data-mb-atc-compare="' + wrap.dataset.mbSection + '"]');
      wrap.querySelectorAll('input[type="radio"]').forEach(function (radio) {
        radio.addEventListener('change', function () {
          wrap.querySelectorAll('.mb-bundle').forEach(function (o) { o.classList.remove('is-selected'); });
          radio.closest('.mb-bundle').classList.add('is-selected');
          if (form) {
            var idInput = form.querySelector('input[name="id"]');
            if (idInput) { idInput.value = radio.value; idInput.disabled = false; }
          }
          priceOut.forEach(function (p) { p.textContent = radio.dataset.price; });
          compareOut.forEach(function (c) {
            c.textContent = radio.dataset.compare || '';
            c.hidden = !radio.dataset.compare;
          });
          var url = new URL(window.location.href);
          url.searchParams.set('variant', radio.value);
          window.history.replaceState({}, '', url.toString());
        });
      });
    });
  }

  /* ---------- Sliding accordions (FAQ, product accordions, benefit cards) ---------- */
  function initAccordions(root) {
    root.querySelectorAll('details.mb-animate').forEach(function (details) {
      if (details.dataset.mbInit) return;
      details.dataset.mbInit = '1';
      var summary = details.querySelector('summary');
      var panel = details.querySelector('[data-mb-panel]') || summary.nextElementSibling;
      if (!summary || !panel) return;
      var animating = false;
      panel.style.overflow = 'hidden';
      summary.addEventListener('click', function (e) {
        e.preventDefault();
        if (animating) return;
        animating = true;
        if (details.open) {
          var fromH = panel.offsetHeight;
          var anim = panel.animate([{ height: fromH + 'px', opacity: 1 }, { height: '0px', opacity: 0 }], { duration: 280, easing: 'ease' });
          anim.onfinish = function () { details.open = false; panel.style.height = ''; animating = false; };
        } else {
          details.open = true;
          var toH = panel.scrollHeight;
          var anim2 = panel.animate([{ height: '0px', opacity: 0 }, { height: toH + 'px', opacity: 1 }], { duration: 320, easing: 'ease' });
          anim2.onfinish = function () { panel.style.height = ''; animating = false; };
        }
      });
    });
  }

  /* ---------- Product gallery thumbnails ---------- */
  function initGalleries(root) {
    root.querySelectorAll('[data-mb-gallery]').forEach(function (gallery) {
      if (gallery.dataset.mbInit) return;
      gallery.dataset.mbInit = '1';
      var main = gallery.querySelector('[data-mb-gallery-main]');
      gallery.querySelectorAll('[data-mb-thumb]').forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          if (main) { main.src = thumb.dataset.mbThumb; main.removeAttribute('srcset'); }
          gallery.querySelectorAll('[data-mb-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
          thumb.classList.add('is-active');
        });
      });
    });
  }

  function init(root) {
    initCarousels(root);
    initCountdowns(root);
    initBundleSelectors(root);
    initAccordions(root);
    initGalleries(root);
  }

  document.addEventListener('DOMContentLoaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
